import theme from "@shared/utils/themeColors";
import React from "react";
import { SidebarActionItem as SidebarActionItemType } from "./types";

interface SidebarActionItemProps {
	item: SidebarActionItemType;
	badge?: React.ReactNode;
}

export const SidebarActionItem: React.FC<SidebarActionItemProps> = ({ item, badge }) => {
	const icon = typeof item.icon === "function" ? item.icon(false) : item.icon;

	return (
		<li className="pl-4 pr-3 py-2 rounded-lg mb-0.5 last:mb-0 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700/50 transition-colors">
			<button
				onClick={item.onClick}
				className={`block w-full text-left ${theme.text.primary} truncate transition duration-150 hover:text-gray-900 dark:hover:text-white`}
			>
				<div className="flex items-center justify-between">
					<div className="flex items-center">
						{icon}
						<span className="text-sm font-medium ml-4 md:opacity-0 md:sidebar-expanded:opacity-100 xl:opacity-100 duration-200">
							{item.label}
						</span>
					</div>
					{badge}
				</div>
			</button>
		</li>
	);
};
